
// SVG Icon: menu
export default { id: "terriajs-menu" };
export const id = "terriajs-menu";
export const name = "menu";
